import { useEffect } from 'react'
import { useHits } from 'react-instantsearch'
import { SearchHit } from '@sh24/ui-components'
import { gtmEvent, events } from '../../services/gtm'

const SearchHits = ({ indexName, updateCount }) => {
  const { items, sendEvent } = useHits()

  const trackClick = (hit) => {
    sendEvent('click', hit, 'Item Clicked') // Algolia insights
    gtmEvent({ ...events.SEARCH_CLICK, label: hit.url }) // GTM
  }

  useEffect(() => {
    updateCount(indexName, items.length)
  }, [items])

  if (!items.length) return null

  return (
    <ul className="pt-base pl-base pr-base m-zero">
      {items.map((item) => (
        <SearchHit key={item.title} hit={item} trackClick={trackClick} />
      ))}
    </ul>
  )
}

export default SearchHits
